import { useEffect, useRef } from 'react'

// Ported verbatim from universal-ovm-fe's `src/hooks/use-effect-once/use-effect-once.hook.tsx`.
// Runs `callback` exactly once, the first time `when` becomes true — used by MarketingCase so the
// merged utmPoa/optimizely post fires once per session, right when authentication succeeds.
const useEffectOnce = (callback, when = true) => {
  const hasRunOnce = useRef(false)
  const callbackRef = useRef(callback)

  useEffect(() => {
    callbackRef.current = callback
  })

  useEffect(() => {
    if (when && !hasRunOnce.current) {
      hasRunOnce.current = true
      callbackRef.current()
    }
  }, [when])
}

export default useEffectOnce
